import { useEffect } from 'react';

const Analytics = () => {
  useEffect(() => {
    const scriptGA = document.createElement('script');
    scriptGA.async = true;
    scriptGA.src = 'https://www.googletagmanager.com/gtag/js?id=G-6MH188PWJ4'; // Замените на ваш ID
    document.head.appendChild(scriptGA);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-6MH188PWJ4'); // Замените на ваш ID

    // Яндекс.Метрика
    const scriptYM = document.createElement('script');
    scriptYM.type = 'text/javascript';
    scriptYM.innerHTML = `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(100834865, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
    `;
    document.head.appendChild(scriptYM);

    // Добавляем noscript для Яндекс.Метрики
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <div><img src="https://mc.yandex.ru/watch/100834865" style="position:absolute; left:-9999px;" alt="" /></div>
    `;
    document.body.appendChild(noscript);
  }, []);

  return null;
};

export default Analytics; 